import { CanActivate, UrlTree } from '@angular/router';
import { AuthenticationFacade } from '../+state/authentication.facade';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src/lib/+state/company-config.facade';
import { NavController } from '@ionic/angular';
import { AccountDetailsFlowType, SelectFunctionType } from '../enum';
import { CHOOSE_LOCATION_TABS, LOCATION_SELECTION_TABS, LOYALTY_TABS } from '@symphony-solo/shared/utils/src/lib';
// import { Tile } from '@symphony-solo/shared/components/src/lib/models/tile.model';
import { catchError, first, map, take } from 'rxjs/operators';

@Injectable()
export class AnonymousUserGuard implements CanActivate {
  public selectFunctionTiles: any = [];
  private functionsTileDictionary = {
    0: {
      id: SelectFunctionType.ClickAndCollect,
      name: '',
      icon: 'click-collect-icon',
    },
    1: {
      id: SelectFunctionType.ScanAndGo,
      name: '',
      icon: 'scan-go-icon',
    },
    2: {
      id: SelectFunctionType.Loyalty,
      name: '',
      icon: 'loyalty-icon',
    },
  };
  private subscriptions: Subscription[] = [];
  constructor(
    private authenticationFacade: AuthenticationFacade,
    private companyConfigFacade: CompanyConfigFacade,
    private navCtrl: NavController
  ) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([this.companyConfigFacade.isAnonymousBrowsing$, this.authenticationFacade.isAuthenticated$, this.companyConfigFacade.isCCAllowed$,]).pipe(
      first(),
      map(([isAnonymous, isAuthenticated, isCCAllowed]) => {
        if ((isAnonymous && isCCAllowed) || isAuthenticated) {
          // User is anonymous, allow access to the route
          if (isAnonymous && !isAuthenticated) {
            const allowedFunctions: SelectFunctionType[] = [0];
            this.selectFunctionTiles = [];
            allowedFunctions.forEach((permission) => {
              this.selectFunctionTiles.push(this.functionsTileDictionary[permission]);
            });
            if (this.selectFunctionTiles.length === 1) {
              this.selectFunction(this.selectFunctionTiles[0]?.id);
              return false;
            } else {
              return true;
            }
          } else {
            this.authenticationFacade.loadAccountDetails(AccountDetailsFlowType.InApp);
            const isGoHome = this.authenticationFacade.goHomebuttonPressed.value;
            if (isGoHome) {
              return true;
            }
            setTimeout(() => {
              this.subscriptions.push(
                this.authenticationFacade.getFunctionsPermissions$.pipe(take(1)).subscribe((permissions) => {
                  this.selectFunctionTiles = [];
                  permissions.forEach((permission) => this.selectFunctionTiles.push(this.functionsTileDictionary[permission]));
                  if (this.selectFunctionTiles.length === 1) {
                    this.selectFunction(this.selectFunctionTiles[0]?.id);
                    return false;
                  } else if (this.selectFunctionTiles.length > 1) {
                    // this.navCtrl.navigateRoot(SELECT_APP_SIMPLE_TABS);
                    this.authenticationFacade.goHomebuttonPressed.next(false);
                    return false;
                  }
                })
              );
            }, 1000);
            if (this.selectFunctionTiles.length > 1) {
              this.authenticationFacade.goHomebuttonPressed.next(false);
              return true;
            }
            if (this.selectFunctionTiles.length === 0) {
              this.authenticationFacade.goHomebuttonPressed.next(false);
              return true;
            }
          }
        } else {
          this.navCtrl.navigateRoot(['/login']);
          return false;
        }
      }),
      catchError((err) => {
        this.navCtrl.navigateRoot(['/login']);
        return of(true);
      })
    );
    /*
    return this.companyConfigFacade
      .getIsAnonymous()
      .toPromise()
      .then(async (isAnonymous: boolean) => {
        if (isAnonymous || this.authenticationFacade.isAuthenticated.value) {
          // User is anonymous, allow access to the route
          if (isAnonymous && !this.authenticationFacade.isAuthenticated.value) {
            const allowedFunctions: SelectFunctionType[] = [0];
            this.selectFunctionTiles = [];
            allowedFunctions.forEach((permission) => {
              this.selectFunctionTiles.push(this.functionsTileDictionary[permission]);
            });
            if (this.selectFunctionTiles.length === 1) {
              this.selectFunction(this.selectFunctionTiles[0]?.id);
              return false;
            } else {
              return true;
            }
          } else {
            this.authenticationFacade.loadAccountDetails(AccountDetailsFlowType.InApp);
            const isGoHome = this.authenticationFacade.goHomebuttonPressed.value;
            if (isGoHome) {
              return true;
            }
            setTimeout(() => {
              this.subscriptions.push(
                this.authenticationFacade.getFunctionsPermissions$.pipe(take(1)).subscribe((permissions) => {
                  this.selectFunctionTiles = [];
                  permissions.forEach((permission) => this.selectFunctionTiles.push(this.functionsTileDictionary[permission]));
                  if (this.selectFunctionTiles.length === 1) {
                    this.selectFunction(this.selectFunctionTiles[0]?.id);
                    return false;
                  } else if (this.selectFunctionTiles.length > 1) {
                    // this.navCtrl.navigateRoot(SELECT_APP_SIMPLE_TABS);
                    this.authenticationFacade.goHomebuttonPressed.next(false);
                    return false;
                  }
                })
              );
            }, 1000);
            if (this.selectFunctionTiles.length > 1) {
              this.authenticationFacade.goHomebuttonPressed.next(false);
              return true;
            }
            if (this.selectFunctionTiles.length === 0) {
              this.authenticationFacade.goHomebuttonPressed.next(false);
              return true;
            }
          }
        } else {
          this.navCtrl.navigateRoot(['/login']);
          return false;
        }
      })
      .catch(() => {
        // An error occurred while checking authentication, redirect to the login page
        this.navCtrl.navigateRoot(['/login']);
        return true;
      });
      */
  }

  public selectFunction(selectFunctionType: SelectFunctionType): void {
    switch (selectFunctionType) {
      case SelectFunctionType.ClickAndCollect:
        this.navCtrl.navigateForward(CHOOSE_LOCATION_TABS);
        break;
      case SelectFunctionType.ScanAndGo:
        this.navCtrl.navigateRoot(LOCATION_SELECTION_TABS);
        // this.paymentCardsFacade.loadPaymentCards(PaymentCardsFlowType.LocationSelection);
        break;
      case SelectFunctionType.Loyalty:
        this.navCtrl.navigateRoot(LOYALTY_TABS);
        break;
    }
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
